document.addEventListener('DOMContentLoaded', function () {
  var trigger = document.getElementById('size-chart-trigger');
  var popup = document.getElementById('size-chart-popup');
  var closeBtn = document.getElementById('close-popup');

  if (!trigger || !popup || !closeBtn) return;

  function setPopupPosition() {
    const content = popup.querySelector('.size-chart-content');
    const close = popup.querySelector('.close');

    if (!content || !close) return;

    let headerOffset = 0;

    // ✅ Fixed header till 1025
    if (window.innerWidth <= 1025) {
      headerOffset = 140;
    } else {
      const header = document.querySelector('header');
      if (!header) return;
      headerOffset = Math.ceil(header.getBoundingClientRect().bottom);
    }

    const closeOffset = Math.abs(close.offsetTop) + close.offsetHeight;
    const modalHeight = content.offsetHeight + closeOffset;
    const viewportHeight = window.innerHeight;

    const availableSpace = viewportHeight - headerOffset;

    // 🔥 NEW: Safe top zone (so X never goes inside header)
    const safeTopThreshold = headerOffset + closeOffset + 10;

    // 👉 Check where center would place modal top
    const centeredTop = (viewportHeight - modalHeight) / 2;

    // ✅ CONDITION 1: Center ONLY if it stays below header safely
    if (
      modalHeight + 40 <= availableSpace &&
      centeredTop >= safeTopThreshold
    ) {
      popup.style.alignItems = 'center';
      popup.style.paddingTop = '0px';
      return;
    }

    // ✅ CONDITION 2: Always sit just below header (tight, no extra gap)
    const paddingTop = safeTopThreshold;

    popup.style.alignItems = 'flex-start';
    popup.style.paddingTop = paddingTop + 'px';
  }

  function openPopup() {
    popup.style.display = 'flex';

    setPopupPosition();
    requestAnimationFrame(setPopupPosition);
    setTimeout(setPopupPosition, 50);
  }

  function closePopup() {
    popup.style.display = 'none';
  }

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    openPopup();
  });

  closeBtn.addEventListener('click', closePopup);

  popup.addEventListener('click', function (e) {
    if (e.target === popup) closePopup();
  });

  window.addEventListener('resize', setPopupPosition);
});